<template>
  <!-- DEVGB -->
  <div class="size1 bg0 where1-parent">
    <div class="size3 flex-col-sb flex-w p-l-50 p-t-25 p-b-44 respon1 reponsive-celular" style="height: 100%;">
      <center class="center-header-login">
        <img src="@/assets/LOGO SEPLAG - AZUL (T) VAZADO.svg" class="icon-login" />
      </center>
      <div class="p-b-10 p-t-5">
        <p class="m1-txt1 p-b-36" style="text-align: center">
          Informe os dados para validar a carteira funcional digital
        </p>
        <form ref="formRef" class="p-grid p-fluid">
          <!-- <div class="wrap-input100 m-b-10 m-t-10 validate-input" data-validate="Nome requerido">
            <span class="p-float-label s2-txt1 placeholder0 input100" style="height: 100%">
              <InputText type="text" id="numrValida" class="s2-txt1 placeholder0 input100" style="border: none"
                v-model="validacao.numrValida" />
              <label for="nome">Código de Validação cxxx</label>
            </span>
          </div> -->

          <!-- <div align="center" style="width: 100%">
            <vue-recaptcha sitekey="6LdZS2seAAAAAGiK_ZQhvkFWIAuB9w_llxrp3lX9" @verify="onVerify" @expired="onExpired"
              ref="recaptcha"></vue-recaptcha>
          </div> -->
          <br />
          <div class="w-full-sm p-col-12">
            <!-- <button class="s2-txt2 size4 bg1 bor1 hov1 trans-04" type="button" @click="validaCarteiraFuncional">
              Validar Carteira Funcional Digital
            </button> -->
          </div>
        </form>
      </div>
      <div class="p-col-12" style="display: flex;justify-content: center;">
        <img src="@/assets/apoio-sti.png" class="img-footer-phone" style="max-width: 400px;" />
      </div>
    </div>
    <CardExibirPDF
      v-if="pdfElement"
      v-model="exibirPDF"
      :nomeDocumento="nomeDocumentoPDF"
      :tituloTela=tituloCard
      :position="'top'"
      :tamanhoTela="'100.em'"
      :alturaTela="'55.em'"
      :pdfElement="pdfElement"
      :blockPrint="true"
      :alteraToolbar="true"
    />
    <div class="flex-c-m bg-img1 size2 where1 overlay1 where2 respon2 display" style=""></div>
    <!-- <CardExibirPDF v-if="pdfElement" v-model="exibirPDF" :nomeDocumento="nomeDocumentoPDF" :tituloTela="this.titulo"
      :position="'top'" :tamanhoTela="'55.em'" :alturaTela="'55.em'" :pdfElement="pdfElement" />  -->
     
        <Dialog  :visible.sync="exibirDialog" modal :style="{ width: '35rem' }">
           <div class="div-dialog">
            <i class="pi" :class="{'pi-check-circle icon-valido':isValido,'pi-times-circle icon-invalido':!isValido}" style="font-size: 8rem"></i>
            <label for="Validação" :class="{'icon-valido':isValido,'icon-invalido':!isValido}">{{textoValidacao}}</label>
           </div>
        </Dialog>
        
  </div>
  
</template>

<script>
import CardExibirPDF from "@/template/CardExibirPDF.vue";
//import { baseApiUrl } from "@/config/global";
import { baseApiUrlCracha } from "@/config/global";
// import { VueRecaptcha } from "vue-recaptcha";

export default {
  // components: { CardExibirPDF, VueRecaptcha },
  modoEdicao: "logar",
  components: { CardExibirPDF },
  data: function () {
    return {
      autoclear: false,
      name: "validaCarteiraFuncionalDigital-publico",
      errors: [],
      exibirPDF: true,
      tituloCard:"Carteira Funcional Digital",
      pdfElement: null,
      exibeMsg: false,
      nomeDocumentoPDF: "Validação da Carteira Funcional Digital",
      exibirDialog:false,
      isValido:false,
      validacao: {
        numrValida: this.hash,
      },
      exibirTelaTermo: false,
      recaptchaWork: false,
      display: false,
      id: null,
      textoValidacao: ""
    };
  },
  mounted() {
    this.validacao.numrValida = this.$route.params.hash.replaceAll("hash=", "");
    this.validaCarteiraFuncional()
  },
  methods: {
    onVerify() {
      this.recaptchaWork = true;
    },
    onExpired: function () {
      this.recaptchaWork = false;
    },
    limparDados() {
      this.validacao.numrValida = "";
    },
    validaCarteiraFuncional() {
   //   e.preventDefault()
      let token = this.validacao.numrValida;
      if (!this.validacao.numrValida) {
        this.$toast.add({
          severity: "error",
          summary: "Informe o Código de validação",
          life: 3000,
        });
      }
     // if (this.recaptchaWork) {
        this.$http
          .get(
            `${baseApiUrlCracha}/publicos/validarCfd/${token}`
          )
          .then((res) => {
            this.pdfElement = res.data.dadosRelatorioBase64;
            this.nomeDocumentoPDF = res.data.nomeArquivo;
            this.exibirPDF = true;
           // this.tituloCard= "Carteira funcional digital"
            //  this.isValido =res.data
            //  this.textoValidacao = res.data?"Este documento é válido":"Este documento é inválido"
            //  this.exibirDialog=true
          });
     // } else {
       /* this.$toast.add({
          severity: "error",
          summary: "Por favor, tente novamente.",
          life: 3000,
        }
        );*/
      //}
      //this.recaptchaWork = false;
     // this.limparDados();
      //window.grecaptcha.reset();
    },

    closeDialog() {
      this.display = false;
    },
  },
};
</script>

<style scoped>
.img-centro {
  text-align: center;
}

.img-atencao {
  width: 36vw;
}

.messages-error {
  background: #ffcdd2;
  border: solid #f44336;
  border-width: 0 0 0 6px;
  color: #b71c1c;
  padding: 1rem 1.5rem;
}

.messages-info {
  background: #b3e5fc;
  border: solid #03a9f4;
  border-width: 0 0 0 6px;
  color: #01579b;
  padding: 1rem 1.5rem;
}

.imagem-fundo {
  background: url("../../assets/img-direito.png");

  background-position: 0% 45%;
  background-repeat: round;
  background-size: auto;
  height: 100.8vh;
  flex-grow: 1;
}

.img-sti {
  margin-bottom: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  width: 8%;
}

.texto-sistema {
  font-size: 20px;
  color: #005494;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.logingridcontrol1 {
  background-color: #005494;
  background: url("../../assets/layout/img-login-pessoas.jpg");
  background-size: 105%;
  height: 75%;
  min-height: 75%;
}

.logingridcontrol2 {
  min-height: 75%;
  height: 75%;
  background-color: #fff;
}

.logingridcontrol2 .border {
  border: 1px dashed #005494;
  margin-top: 2px;
  border-left: 0;
  height: 100%;
}

.p-grid {
  margin-right: 0;
  margin-left: 0;
}

.loginformgvesqueci a {
  color: white;
}

.bg1 {
  background-color: #007ad9;
}

.bg2 {
  background-color: green;
}

.wrap-pic1 {
  width: 70%;
}

.bg-img1 {
  background-image: url("../../assets/administracao.jpg");
}

.texto-sistema {
  font-size: 40px;
  color: #005494;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.icon-login {
  width: 50%;
  margin-top: 4vw;
  margin-bottom: 4vw;
  margin-left: -2.2vw;
}

.img-top-phone {
  width: 90%;
  margin-top: 12vw;
  margin-left: -6vw;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.view-phone {
  display: none;
}

@media screen and (max-width: 40em) {
  .img-atencao {
    width: 100% !important;
  }

  .display {
    display: none !important;
  }

  .reponsive-celular {
    padding-right: 26px !important;
    padding-left: 18px !important;
  }

  .wrap-pic1 {
    width: 100%;
  }

  .view-phone {
    display: block;
  }

  .logingridcontrol1 {
    display: none;
  }

  .texto-sistema {
    margin-top: 12vw;
  }

  .img-footer-phone {
    width: 37vw;
    margin-left: 25vw;
    margin-top: 25vw;
  }
}

div.p-dropdown {
  padding: 0 22px 0 22px;
  width: 100%;
  border: 2px solid #e6e6e6;
  font-family: "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 15px;
  line-height: 2.5;
  width: 100%;
}
.div-dialog{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    font-size: 2rem
}
.icon-valido{
  color: #196606;
}

.icon-invalido{
  color: #b71c1c;
}
</style>
